export default __webpack_public_path__ + "static/media/search-alt.4d456d1b.svg";